module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/6JENkn/Images/cover.jpg?1685327487328",
      "alt": "This image is the cover for the book Quite A Spectacle"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Quite A Spectacle\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Max moved away from his family to be with Michael, and his family never got over it. Now, for the first time in almost a decade, he’s going to return to London for the Christmas celebrations. He’s confident his family will welcome Michael with open, loving arms. At least that's what he tells himself.")]), _vm._v(" "), _c('p', [_vm._v("Michael doesn't have his head buried in the sand. He knows he has a lot to prove this Christmas, and he’s not sure if he’s up to the task. All these years and he’d never considered having to spend a holiday with Max’s family. Now that it’s happening he’s not scared to admit it—he’s terrified.")]), _c('p', [_c('i', [_vm._v("A story from the Dreamspinner Press 2014 Advent Calendar package \"Celebrate!\".")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Meg Harding\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0